import { Payment } from "@omni/types/api/cart/bff/shared/payment.model";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { DamImage } from "@/utils/dam.utils";
import { formatPrice } from "@/utils/price.utils";

type PaymentMethodComponentProps = {
    payment: Payment;
    showAmount: boolean;
};

const PaymentMethodComponent = ({
    payment,
    showAmount
}: PaymentMethodComponentProps) => {
    const { t } = useGranite();

    const issuerName = payment.issuer
        ? t(`checkout.psp.paymentIssuer.${payment.issuer}`.toLowerCase())
        : undefined;

    const displayName =
        issuerName ??
        t(
            `order.psp.paymentMethods.name.${payment.paymentMethodCode}`.toLowerCase()
        );

    const displayPrice = showAmount
        ? ` (${formatPrice(payment.amount, { currency: true })})`
        : null;

    return (
        <li className={cn("tw:flex tw:items-center tw:gap-1")}>
            <img
                width={30}
                src={DamImage.icon.payment[
                    payment.issuer || payment.paymentMethodCode
                ]()}
                alt={displayName}
                role={"presentation"}
                onError={(e) => e.currentTarget.classList.add("d-none")}
            />
            <span>
                {displayName}
                {displayPrice}
            </span>
        </li>
    );
};

export { PaymentMethodComponent };
